var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.45 44.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#625243;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.64,12.23a40,40,0,0,1,7-4.5,67.62,67.62,0,0,1,7.65-3.35A76.34,76.34,0,0,1,236.64.56a82.8,82.8,0,0,1,33.67,3,88.3,88.3,0,0,1,29.75,15.71,83.69,83.69,0,0,1,21.39,25.07c-2.46-1.33-4.74-2.78-7-4.19-1.18-.67-2.31-1.37-3.45-2s-2.22-1.43-3.39-2l-3.4-2c-.57-.32-1.11-.69-1.68-1l-1.71-.93c-1.15-.61-2.26-1.26-3.37-1.9s-2.3-1.15-3.42-1.77A160.64,160.64,0,0,0,266.26,17a138.35,138.35,0,0,0-29.33-5.48A159.46,159.46,0,0,0,205.64,12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,44.81a39.72,39.72,0,0,1,4.07-7.25A66.17,66.17,0,0,1,9.26,31,75,75,0,0,1,21.91,20,82.77,82.77,0,0,1,53.07,6.88,88.34,88.34,0,0,1,86.71,6.8a83.84,83.84,0,0,1,30.65,12.12c-2.79,0-5.49-.23-8.16-.42-1.35,0-2.68-.12-4-.19s-2.63-.22-4-.22l-3.93-.16c-.66,0-1.3-.08-2-.09l-2,0c-1.3,0-2.58-.05-3.87-.09s-2.57.05-3.85,0a161.38,161.38,0,0,0-29.9,2.84,138.42,138.42,0,0,0-28.48,8.92A159,159,0,0,0,0,44.81Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.f0d02828.svg";
export { ForwardRef as ReactComponent };